module.exports = __webpack_public_path__ + "img/movie_label2.3b2c91d2.svg";